// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ezUm","label":"Completed_label__2bZsu"};